// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"4da34929","732":"4e5a97df","977":"70402d92"}[chunkId] + ".chunk.js";
};